export default {
  Inbound: 'Inbound',
  Outbound: 'Outbound',
  log: 'Log',
  save: 'Save and new',
  discard: 'Discard and new',
  hangup: 'Hangup',
  reject: 'To Voicemail',
  saveDraftAndCreateNewLog: 'Save draft and create new call log',
} as const;
